<template>
  <div>
    <b-modal id="modalOnceService" ref="modalOnceService" :title="$t('One-time service')" hide-footer>
      <div v-if="editItem && (serviceType === 1)">
        <b-tabs pills card>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
              <b-form-input type="text" disabled v-model="editItem.parent_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="suppliertList" v-model="editItem.invoice_sup_id"/>
            </b-form-group>
            <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
              <b-form-checkbox v-model="editItem.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
              <b-form-checkbox v-model="editItem.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Service parameters')">
            <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.cost" aria-describedby="inputFeedbackCost" :state="editItem.cost !== ''"/>
              <b-form-invalid-feedback id="inputFeedbackCost">
                {{ $t('Enter cost') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Delete from group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="groupList" v-model="editItem.drop_from_group"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="contractList" v-model="editItem.contract_type"/>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="saveOnceService" @cancel="$refs.modalOnceService.hide"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    serviceType: null,
    suppliertList: null,
    contractList: null,
    groupList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  methods: {
    async saveOnceService () {
      if (!this.editItem.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.parent_id === 0) this.editItem.parent_id = -1
        this.editItem.link_by_default = Number(this.editItem.link_by_default)
        this.editItem.multiple_linking = Number(this.editItem.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.tariff_id = this.currentRowTariffPlans.id
      }
      this.editItem.cost = Number(this.editItem.cost)
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_ONE_TIME_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_ONE_TIME_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalOnceService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_id : response.data.service_id

          let invID = this.editItem.invoice_sup_id ? this.editItem.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.multiple_linking ? this.editItem.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formOnceService.vue